/*
********************************************************************************
- Archivo : client/src/components/User/AddUserDetails.js
- Proyecto: CB30
- Propósito: Componente para diligenciar y actualizar los datos personales del usuario.
********************************************************************************
*/

import React, { Component } from "react";
import { graphql } from "react-apollo";
import _ from "lodash";

// Components
import UserDetailsForm from "./UserDetailsForm";

// Query
import query from "../../queries/fetchUser";

// Mutation
import mutation from "../../mutations/editUserDetails";

class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getStateFromChild = this.getStateFromChild.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillUpdate(nextProps) {
    if (nextProps.data.user.validated) {
      this.props.history.push("/dashboard");
    }
  }
  getStateFromChild(state) {
    const cleanState = _.omit(state, "errs");
    this.handleSubmit(cleanState);
  }
  handleSubmit(payload) {
    const userId = this.props.data.user.id;
    this.props
      .mutate({
        variables: { ...payload, userId }
      })
      .then(() => this.props.data.refetch());
  }
  render(props) {
    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }
    return (
      <div className="container">
        <br />
        <h1>Detalles del usuario</h1>
        <br />
        <UserDetailsForm
          sendStateToParent={this.getStateFromChild}
          userId={this.props.data.user.id}
          hideBtn={false}
        />
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default graphql(mutation)(graphql(query)(UserDetails));



// WEBPACK FOOTER //
// ./src/components/User/AddUserDetails.js